import React from "react";
import { BoiTooltip } from "../../boi-tooltip/boi-tooltip";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import {
    StyledField,
    LabelContainer,
    FieldDescription,
    FieldError
} from "./field-component.styles";

const GravityField = ({
    label,
    type,
    id,
    formId,
    error,
    showError,
    children,
    hidden,
    description,
    labelClass,
    visibility,
    cssClass,
    customTooltip,
    descriptionPlacement,
    isRequired
}) => {
    return (
        visibility !== "hidden" ? (
            <StyledField
                className={
                    (cssClass ? ` ${cssClass}` : "") +
                    (type === "hidden" ? " hide" : "") +
                    (error ? " error" : "")
                }
                id={`field_${formId}_${id}`}>
                {type !== "html" && label && (
                    <LabelContainer>
                        <label
                            htmlFor={`input_${formId}_${id}`}
                            className={`field-label ${labelClass}`}>
                            {label}{" "}
                            {isRequired ? (
                                ""
                            ) : (
                                <span className="optional">{"(optional)"}</span>
                            )}
                        </label>

                        {customTooltip && hidden !== true && (
                            <BoiTooltip
                                id={`tooltip-${formId}_${id}`}
                                customTooltip={customTooltip}>
                                {customTooltip}
                            </BoiTooltip>
                        )}
                    </LabelContainer>
                )}
                {description && (
                    <FieldDescription
                        className={`
                            ${
                                descriptionPlacement &&
                                descriptionPlacement === "below"
                                    ? " below"
                                    : ""
                            }
                        `}>
                        <BoiReactMarkdown>{description}</BoiReactMarkdown>
                    </FieldDescription>
                )}
                {children}
                {error && showError && <FieldError>{error}</FieldError>}
            </StyledField>
        ) : null
    );
};
GravityField.defaultProps = {
    labelClass: "",
    label: "",
    type: "",
    id: "",
    formId: "",
    error: "",
    showError: true,
    children: null,
    hidden: false,
    description: "",
    visibility: "",
    cssClass: "",
    customTooltip: "",
    descriptionPlacement: "",
    isRequired: false
};

export default GravityField;
